import React, { useState, useEffect } from "react";
import {
  Alert,
  Button,
  ButtonGroup,
  Container,
  // Card,
  Col,
  Form,
  Row,
  Modal,
  Spinner,
  Dropdown,
  Tooltip,
  OverlayTrigger,
  // ListGroup,
  Accordion,
  Card,
  Table,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
// import moment from "moment";
// import * as Yup from "yup";
// import { Formik } from "formik";

import CustomNavbar from "../../../components/CustomNavbar";
// import CustomTable from "../../../components/CustomTable";
// import CustomPagint from "../../../components/CustomPagint";

// import messages from "../../../redux/messages";
import SidebarEvaluacionDesempenio from "../../../components/evaluacion_desempenio/SidebarEvaluacionDesempenio";
// import { getPlazasVacantes } from "../../../redux/seleccionContratacion/plazas_vacantes/actions";
import {
  getFactor,
  // resetFactor,
} from "../../../redux/evaluacion_desempenio/Factor/actions";
import { get_tasks_descriptors } from "../../../redux/tasks/actions";
import { Link, useHistory } from "react-router-dom";
import LinkDescriptor from "../../../components/evaluacion_desempenio/LinkDescriptor";
import { getGeneralInfo } from "../../../redux/descriptorsProfiles/GeneralInfo/actions";
import { getTraining } from "../../../redux/descriptorsProfiles/Formation/actions";
import { getPreparation } from "../../../redux/descriptorsProfiles/Preparation/actions";
import { getTechnicalKnowledgeAcquired } from "../../../redux/descriptorsProfiles/TechnicalKnowledgeAcquired/actions";
import { getExperience } from "../../../redux/descriptorsProfiles/Experience/actions";
import { getIndikators } from "../../../redux/descriptorsProfiles/indikators/actions";
import { getJobFunction } from "../../../redux/descriptorsProfiles/JobFunction/actions";
// import {
//   getFactorTemplate,
//   getFactorTemplateById,
//   saveFactorTemplate,
//   editFactorTemplate,
//   deleteFactorTemplate,
// } from "../../../redux/evaluacion_desempenio/FactorTemplate/actions";
import Question from "../../../components/evaluacion_desempenio/Question";
// import {
//   getClassification,
//   saveClassification,
//   editClassification,
//   deleteClassification,
// } from "../../../redux/Classification/actions";
// import { getPesoCompetencias } from "../../../redux/evaluacion_desempenio/pesoCompetencia/actions";
import { getFactorTemplateById } from "../../../redux/evaluacion_desempenio/FactorTemplate/actions";

const FactorQuestions = (props) => {
  const filtersFuncion = [
    { id: "descripcion", desc: "Descripción función" },
    { id: "codigo", desc: "Codigo de función" },
  ];
  // const filtersPosition = [
  //   { id: "descripcion", desc: "Descripción posición" },
  //   { id: "codigo", desc: "Codigo de posición" },
  // ];

  const [_funcion, setFuncion] = useState(false);
  const [_viewMessege, setViewMessege] = useState(false);
  const [_continue, setContinue] = useState(true);
  const [alphabet, setAlphabet] = useState([]);
  const [orderAlphabetic, setOrderAlphabetic] = useState(true);
  const [descriptorCompleto, setDescriptorCompleto] = useState(false);
  const [showModalFunction, setShowModalFunction] = useState(false);
  // const [showModalPosition, setShowModalPosition] = useState(false);
  const [show, setShow] = useState(false);
  const [functionSelected, setFunctionSelected] = useState(null);
  // const [validatedFunction, setValidatedFunction] = useState(false);
  const [filter, setFilter] = useState("");
  const [positionSelected, setPositionSelected] = useState(null);
  const [resetFunction, setResetFunction] = useState(false);
  const [_clasificacion, setClasificacion] = useState("");
  const [tipoBusquedaFuncion, setTipoBusquedaFuncion] = useState({
    id: "descripcion",
    desc: "Descripción función",
  });
  // const [tipoBusquedaPosition, setTipoBusquedaPosition] = useState({
  //   id: "descripcion",
  //   desc: "Descripción posición",
  // });
  // const dataClasificacion = useSelector(
  //   (store) => store.classification.classification
  // );
  // const loadingClasificacion = useSelector(
  //   (store) => store.classification.loading
  // );

  const dispatch = useDispatch();
  const history = useHistory();

  // const schema = Yup.object().shape({
  //   filterEmployee: Yup.string().required("**Campo requerido"),
  // });

  // const { factorTemplatesLength, factorTemplates, factorTemplateError } =
  //   useSelector((store) => store.factorTemplate);
  // const loadingFactorTemplate = useSelector(
  //   (store) => store.factorTemplate.loading
  // );

  const { loading, factorsLength, factors, factorError } = useSelector(
    (store) => store.factor
  );

  const { tasks, loader, tasksLength } = useSelector((store) => store.tasks);

  // const { loaderPlazasVacantes, plazasVacantes, plazasVacantesFalla } =
  //   useSelector((store) => store.plazasVacantes);

  // Descriptor de la función
  const {
    loading: loadingGeneralInfo,
    generalInfos,
    // generalInfosLength,
    // generalInfoError,
  } = useSelector((store) => store.generalInfo);

  const {
    loading: jobLoading,
    jobFunctionsLength,
    jobFunctions,
  } = useSelector((store) => store.jobFunction);

  const { loaderIndikators, indikators } = useSelector(
    (store) => store.indikators
  );

  const {
    loading: trainingLoading,
    trainingsLength,
    // trainings,
  } = useSelector((store) => store.training);

  const {
    loading: preparationLoading,
    preparationsLength,
    // preparations,
  } = useSelector((store) => store.preparation);

  const {
    loading: technicalKnowledgeAcquiredLoading,
    technicalKnowledgeAcquiredsLength,
    // technicalKnowledgeAcquireds,
  } = useSelector((store) => store.technicalKnowledgeAcquired);

  const {
    loading: experienceLoading,
    experiencesLength,
    // experiences,
  } = useSelector((store) => store.experience);

  let funcionOptions = [];
  tasks &&
    tasks.map((task) => {
      funcionOptions = [
        ...funcionOptions,
        {
          id: task.id,
          label: task.descripcion
            ? `${task.codigo} / ${task.descripcion.toUpperCase()}`
            : "",
          item: task,
        },
      ];
    });

  let depOptions = [];
  generalInfos &&
    generalInfos.map((dep) => {
      const isDuplicate = depOptions.find((_dep) => _dep.id === dep.division);

      if (!isDuplicate && dep.division) {
        depOptions.push({
          id: dep.division,
          label: dep.list_division[0].descripcion,
        });

        return true;
      }

      return false;
    });

  let factorSorted = [];
  factors &&
    factors.map((fact, index) => {
      if (parseInt(index) > 1) {
        factorSorted.push(fact);
      }
    });

  const { loadingById, factorTemplate } = useSelector(
    (store) => store.factorTemplate
  );

  // const getAClassification = (filt = filter) =>
  //   dispatch(
  //     getClassification(
  //       {
  //         filter: filt,
  //       },
  //       2
  //     )
  //   );

  // Métodos

  // useEffect(() => {
  //   dispatch(getFactor({}));
  // }, []);

  useEffect(() => {
    //_getFactor();
    // dispatch(resetFactor());
    // getAClassification({});
    dispatch(getFactorTemplateById(parseInt(props.match.params.idPlantilla)));
  }, [props.match.params.idPlantilla]);

  useEffect(() => {
    if (factorTemplate.id) {
      _getFactor(factorTemplate.list_periodicidad[0].clasificacion);
    }
  }, [factorTemplate]);

  // useEffect(() => {
  //   if (functionSelected && !_viewMessege && positionSelected) {
  //     dispatch(
  //       getFactorTemplate({
  //         tipo_busqueda: "funcion",
  //         filter: functionSelected.id,
  //         segundo_tipo_busqueda: "posicion",
  //         segundo_filter: positionSelected.id,
  //       })
  //     );
  //   }
  // }, [functionSelected, _viewMessege, positionSelected]);

  useEffect(() => {
    const _factorSorted = [];
    factors &&
      factors
        .filter((e) => e.tipo_factor === 0)
        .map((fact, index) => {
          // if (parseInt(index) > 1) {
          _factorSorted.push(fact);
          // }
        });
    // setAlphabet(_factorSorted);
    const sorted = [..._factorSorted].sort((a, b) =>
      a.nombre > b.nombre ? 1 : b.nombre > a.nombre ? -1 : 0
    );
    setAlphabet(sorted);
  }, [factors]);

  useEffect(() => {
    const _length = parseInt(generalInfos.length) - 1;
    if (_funcion && generalInfos.length > 0) {
      dispatch(
        getTraining({
          tipo_busqueda: "descriptor_id",
          filter: parseInt(generalInfos[_length].id),
        })
      );
      dispatch(
        getPreparation({
          tipo_busqueda: "descriptor_id",
          filter: parseInt(generalInfos[_length].id),
        })
      );
      dispatch(
        getTechnicalKnowledgeAcquired({
          tipo_busqueda: "descriptor_id",
          filter: parseInt(generalInfos[_length].id),
        })
      );
      dispatch(
        getExperience({
          tipo_busqueda: "descriptor_id",
          filter: parseInt(generalInfos[_length].id),
        })
      );
      dispatch(
        getIndikators({
          tipo_busqueda: "descriptor_id",
          filter: parseInt(generalInfos[_length].id),
        })
      );
      dispatch(
        getJobFunction({
          tipo_busqueda: "descriptor",
          filter: parseInt(generalInfos[_length].id),
        })
      );
    } else {
      setDescriptorCompleto(false);
      setViewMessege(true);
      setResetFunction(true);
    }
  }, [generalInfos]);

  useEffect(() => {
    if (
      !jobLoading &&
      !experienceLoading &&
      !technicalKnowledgeAcquiredLoading &&
      !preparationLoading &&
      !trainingLoading &&
      !loaderIndikators
    ) {
      if (
        jobFunctionsLength > 0 &&
        indikators &&
        indikators.count > 0 &&
        technicalKnowledgeAcquiredsLength > 0 &&
        preparationsLength > 0 &&
        experiencesLength > 0 &&
        trainingsLength > 0
      ) {
        setDescriptorCompleto(true);
        setShowModalFunction(false);
        setViewMessege(false);
        setResetFunction(false);
      } else {
        setDescriptorCompleto(false);
        setViewMessege(true);
        setResetFunction(true);
      }
    }
  }, [
    jobFunctionsLength,
    indikators,
    technicalKnowledgeAcquiredsLength,
    preparationsLength,
    experiencesLength,
    trainingsLength,
    jobLoading,
    experienceLoading,
    technicalKnowledgeAcquiredLoading,
    preparationLoading,
    trainingLoading,
    loaderIndikators,
  ]);

  // const onAddFunction = () => {
  //   setShowModalFunction(true);
  //   setFuncion(false);
  //   setViewMessege(false);
  //   setContinue(true);
  // };

  // const onAddPosition = () => {
  //   setShowModalPosition(true);
  // };

  const onSearchFunction = (e) => {
    if (e.key === "Enter") {
      if (!!e.target.value.trim()) {
        setViewMessege(false);
        setContinue(true);
        dispatch(
          get_tasks_descriptors({
            filter: e.target.value,
            tipo_busqueda: tipoBusquedaFuncion.id,
          })
        );
      }
    }
  };

  const _getFactor = (clasi = _clasificacion) =>
    dispatch(
      getFactor(
        props.match.params.id
          ? { id: parseInt(props.match.params.id) }
          : {
              tipo_busqueda: "periodicidad",
              filter: parseInt(props.match.params.idPeriodicidad),
              tipo_busqueda_2: "clasificacion",
              filter_2: clasi,
            },
        props.match.params.id
      )
    );
  // const onSearch = (e) => {
  //   e.preventDefault();
  //   setFilter(e.currentTarget.value);
  //   _getFactor(e.currentTarget.value);
  // };

  // const onSearchPosition = (e) => {
  //   if (e.key === "Enter") {
  //     if (!!e.target.value.trim()) {
  //       dispatch(
  //         getPlazasVacantes({
  //           filter: e.target.value,
  //           tipo_busqueda: tipoBusquedaPosition.id,
  //         })
  //       );
  //     }
  //   }
  // };

  const onShowSidebar = () => setShow(show ? false : true);

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarEvaluacionDesempenio show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-start align-items-center">
            <Button
              onClick={() =>
                history.push(
                  `/evaluacion-desempenio/admin/plantillas-por-periodo`
                )
              }
              variant="link"
              className="font-weight-bold mr-4 text-dark"
            >
              <i className="material-icons">arrow_back</i>
            </Button>
            <h6 className="font-weight-bold text-uppercase">
              Preguntas de evaluación por factor
            </h6>
          </div>
          <Col sm="12" md="12">
            <hr />
          </Col>
          {/* <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
            <Form as={Col}>
              <Col className="px-0">
                <Row className="justify-content-sm-start align-items-center flex-nowrap">
                  <Form.Group md="6" xs="auto" className="mb-0 px-0" as={Col}>
                    <Row className="mb-0">
                      <Form.Label column xs="auto">
                        Función:
                      </Form.Label>
                      <Col md="7" sm="8" xs="auto">
                        <Row>
                          <Col>
                            <Form.Control
                              value={
                                functionSelected && !_viewMessege
                                  ? `${functionSelected.codigo} / ${functionSelected.descripcion}`
                                  : ""
                              }
                              className="rounded-pill"
                              type="text"
                              readOnly
                            ></Form.Control>
                          </Col>
                        </Row>
                      </Col>
                      <Col xs="auto">
                        <ButtonGroup>
                          <Button
                            variant="light"
                            size="sm"
                            className="rounded-circle"
                            onClick={() => onAddFunction()}
                          >
                            <i className="material-icons">search</i>
                          </Button>
                        </ButtonGroup>
                      </Col>
                    </Row>
                  </Form.Group>
                  <Form.Group className="mb-0 px-0" as={Col}>
                    <Row className="mb-0">
                      <Form.Label column xs="auto">
                        Puesto
                      </Form.Label>
                      <Col md="7" sm="8" xs="auto">
                        <Row>
                          <Col>
                            <Form.Control
                              value={
                                positionSelected
                                  ? `${positionSelected.codigo} / ${positionSelected.descripcion}`
                                  : ""
                              }
                              className="rounded-pill"
                              type="text"
                              readOnly
                            ></Form.Control>
                          </Col>
                        </Row>
                      </Col>
                      <Col xs="auto">
                        <ButtonGroup>
                          <Button
                            variant="light"
                            size="sm"
                            className="rounded-circle"
                            onClick={() => onAddPosition()}
                          >
                            <i className="material-icons">search</i>
                          </Button>
                        </ButtonGroup>
                      </Col>
                    </Row>
                  </Form.Group>
                </Row>
              </Col>
            </Form>
          </div>
          <Col sm="12" md="12">
            <hr />
          </Col> */}
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-end align-items-center">
            <Form
            // onSubmit={onSearch}
            >
              <Row className="justify-content-sm-end align-items-center flex-nowrap">
                {/* <Form.Control
                  as="select"
                  className=" rounded-pill"
                  onChange={(e) => {
                    onSearch(e);
                  }}
                >
                  <option value="" selected disabled>
                    Seleccionar clasificación...
                  </option>
                  {dataClasificacion
                    .sort((a, b) =>
                      a.nombre > b.nombre ? 1 : b.nombre > a.nombre ? -1 : 0
                    )
                    .map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.nombre}
                      </option>
                    ))}
                </Form.Control> */}
                <Col xs="auto">
                  <ButtonGroup>
                    <Link
                      className="btn btn-primary rounded-pill mr-1 d-flex flex-wrap justify-content-center align-items-center"
                      style={{ textDecoration: "none" }}
                      to={`/evaluacion-desempenio/admin/factor`}
                      // target="_blank"
                    >
                      Factores
                    </Link>
                    <Button
                      variant="primary"
                      size="sm"
                      className="rounded mr-3"
                      onClick={() => {
                        const _orderAlphabetic = orderAlphabetic;
                        setOrderAlphabetic(!orderAlphabetic);
                        if (!_orderAlphabetic) {
                          const sorted = [...alphabet].sort((a, b) =>
                            a.nombre > b.nombre
                              ? 1
                              : b.nombre > a.nombre
                              ? -1
                              : 0
                          );
                          setAlphabet(sorted);
                        } else {
                          setAlphabet(factorSorted);
                        }
                      }}
                    >
                      <i className="material-icons">sort_by_alpha</i>
                    </Button>
                  </ButtonGroup>
                </Col>
              </Row>
            </Form>
          </div>
          {loading || loadingById ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : (
            factorsLength > 0 && (
              <>
                <Col>
                  {/* {factors.map(
                    (item, _index) =>
                      parseInt(_index) < 2 && (
                        <>
                          <div key={item.id} className="my-3">
                            <Accordion>
                              <Card>
                                <Accordion.Toggle
                                  as={Card.Header}
                                  eventKey={toString(_index)}
                                  className="bg-acordion-factor d-flex flex-wrap justify-content-between align-items-center"
                                >
                                  <div className="d-flex flex-wrap justify-content-between align-items-center">
                                    <i className="material-icons mr-2">
                                      control_point
                                    </i>{" "}
                                    {item.nombre}
                                  </div>
                                  <div className="d-flex flex-wrap justify-content-between align-items-center">
                                    Peso: {item.peso} %
                                  </div>
                                </Accordion.Toggle>
                                <Accordion.Collapse eventKey={toString(_index)}>
                                  <Card.Body>
                                    <Container>
                                      {jobLoading || loaderIndikators ? (
                                        <div className="d-flex justify-content-center">
                                          <Spinner
                                            animation="border"
                                            role="status"
                                            className="d-flex justify-content-center"
                                          />
                                        </div>
                                      ) : (
                                        <>
                                          <Question
                                            index={parseInt(_index)}
                                            item={item}
                                            functionSelected={functionSelected}
                                            positionSelected={positionSelected}
                                            _viewMessege={_viewMessege}
                                            jobFunctions={jobFunctions}
                                            indikators={indikators}
                                            resetFunction={resetFunction}
                                          />
                                        </>
                                      )}
                                    </Container>
                                  </Card.Body>
                                </Accordion.Collapse>
                              </Card>
                            </Accordion>
                          </div>
                        </>
                      )
                  )} */}
                  {alphabet.map((item, _index) => (
                    <>
                      <div key={item.id} className="my-3">
                        <Accordion>
                          <Card>
                            <Accordion.Toggle
                              as={Card.Header}
                              eventKey={toString(_index)}
                              className="bg-acordion-factor d-flex flex-wrap justify-content-between align-items-center"
                            >
                              <div className="d-flex flex-wrap justify-content-between align-items-center">
                                <i className="material-icons mr-2">
                                  control_point
                                </i>{" "}
                                {item.factor
                                  ? item.list_factor[0].nombre
                                  : "No ingresado"}
                              </div>
                              <div className="d-flex flex-wrap justify-content-between align-items-center">
                                Clasificación:{" "}
                                {item.list_clasificacion[0].nombre}
                                &nbsp; &nbsp; &nbsp; Peso: {item.peso} %
                              </div>
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey={toString(_index)}>
                              <Card.Body>
                                <Container>
                                  <Question
                                    index={parseInt(_index) + 2}
                                    item={item}
                                    functionSelected={functionSelected}
                                    positionSelected={positionSelected}
                                    _viewMessege={_viewMessege}
                                    jobFunctions={jobFunctions}
                                    indikators={indikators}
                                    idPlantilla={parseInt(
                                      props.match.params.idPlantilla
                                    )}
                                    idPeriodicidad={parseInt(
                                      props.match.params.idPeriodicidad
                                    )}
                                  />
                                </Container>
                              </Card.Body>
                            </Accordion.Collapse>
                          </Card>
                        </Accordion>
                      </div>
                    </>
                  ))}
                </Col>
              </>
            )
          )}
          {!loading &&
            !loadingById &&
            alphabet.length === 0 &&
            factorError === "" && (
              <Alert variant="info" className="my-4 mx-3">
                Aún no hay pesos por factores registrados, comience agregando
                algunos
              </Alert>
            )}
          {/* {!loading && filter === "" && (
            <Alert variant="info" className="my-4">
              Seleccione una clasificación.
            </Alert>
          )} */}
          {/* {!loading && factorsLength === 0 && factorError === "" && (
            <Alert variant="info" className="my-4">
              Aún no hay registros, comience agregando algunos
            </Alert>
          )} */}
          {factorError !== "" && (
            <Alert variant="danger" className="mt-4 mb-1 mx-3">
              {factorError}
            </Alert>
          )}
        </Container>
      </div>
      <Modal
        show={showModalFunction}
        onHide={() => setShowModalFunction(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title className="text-muted">Seleccionar función</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row className="justify-content-end align-items-center flex-nowrap">
            <Col xs="auto">
              <Form.Label className="m-0" htmlFor="filterEmployee">
                <b>{tipoBusquedaFuncion.desc}:</b>
              </Form.Label>
            </Col>
            <Col xs="auto">
              <Form.Control
                id="filterEmployee"
                name="filterEmployee"
                className={`rounded-pill form-control-sm`}
                type="search"
                onKeyDown={onSearchFunction}
              ></Form.Control>
              <Form.Control.Feedback type="invalid">
                **Campo requerido
              </Form.Control.Feedback>
            </Col>
            <Col>
              <ButtonGroup>
                <OverlayTrigger
                  placement="auto"
                  overlay={<Tooltip {...props}>Seleccionar Filtrado</Tooltip>}
                >
                  <Dropdown className="ml-3 mr-3">
                    <Dropdown.Toggle variant="primary" className="btn-sm font">
                      <i className="material-icons">filter_list</i>
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      {filtersFuncion.map((item) => (
                        <Dropdown.Item
                          onClick={() => setTipoBusquedaFuncion(item)}
                          key={item.id}
                        >
                          {item.desc}
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                </OverlayTrigger>
              </ButtonGroup>
            </Col>
          </Row>
          <div className="my-3">
            {loader ? (
              <div className="d-flex justify-content-center">
                <Spinner
                  animation="border"
                  role="status"
                  className="d-flex justify-content-center"
                />
              </div>
            ) : tasksLength > 0 ? (
              <div>
                {!loadingGeneralInfo &&
                !jobLoading &&
                // !experienceLoading &&
                // !technicalKnowledgeAcquiredLoading &&
                // !preparationLoading &&
                // !trainingLoading &&
                !loaderIndikators &&
                _viewMessege &&
                _funcion &&
                generalInfos.length === 0 ? (
                  <div className="mb-1 border-left border-danger">
                    <Alert className="mb-0" variant="light">
                      <p>
                        No existe un descriptor para esta función, ¿Desea
                        agregar uno,{" "}
                        <Link
                          to={`/descriptores-perfiles/seleccion-del-descriptor/${
                            functionSelected && functionSelected.id
                              ? functionSelected.id
                              : ""
                          }/${
                            functionSelected && functionSelected.descripcion
                              ? functionSelected.descripcion
                              : ""
                          }`}
                          // target="_blank"
                        >
                          si
                        </Link>{" "}
                        o{" "}
                        <Link
                          onClick={() => {
                            setViewMessege(false);
                            setContinue(false);
                          }}
                        >
                          no
                        </Link>
                        ?
                      </p>
                    </Alert>
                  </div>
                ) : null}
                {!loadingGeneralInfo &&
                !jobLoading &&
                // !experienceLoading &&
                // !technicalKnowledgeAcquiredLoading &&
                // !preparationLoading &&
                // !trainingLoading &&
                !loaderIndikators &&
                !descriptorCompleto &&
                _viewMessege &&
                _funcion &&
                generalInfos.length !== 0 ? (
                  <div className="mb-1 border-left border-danger">
                    <Alert className="mb-0" variant="light">
                      <p>
                        El descriptor para esta función no está completo, ¿Desea
                        completarlo ahora,{" "}
                        <Link
                          to={`/descriptores-perfiles/seleccion-del-descriptor/${
                            functionSelected && functionSelected.id
                              ? functionSelected.id
                              : ""
                          }/${
                            functionSelected && functionSelected.descripcion
                              ? functionSelected.descripcion
                              : ""
                          }`}
                          // target="_blank"
                        >
                          si
                        </Link>{" "}
                        o{" "}
                        <Link
                          onClick={() => {
                            setViewMessege(false);
                            setContinue(false);
                          }}
                        >
                          no
                        </Link>
                        ?
                      </p>
                    </Alert>
                  </div>
                ) : null}
                {!_continue ? (
                  <div className="mb-1 border-left border-danger">
                    <Alert className="mb-0" variant="light">
                      <p>Seleccione otra función para poder continuar.</p>
                    </Alert>
                  </div>
                ) : null}
                <Table responsive>
                  <tbody>
                    {tasks.map((task) => (
                      <tr>
                        <td>
                          {task.codigo} / {task.descripcion}
                        </td>
                        <td>
                          <ButtonGroup>
                            <OverlayTrigger
                              placement="left"
                              overlay={
                                <Tooltip
                                  style={{ zIndex: 999999999999 }}
                                  {...props}
                                >
                                  Seleccionar función
                                </Tooltip>
                              }
                            >
                              <Button
                                variant="light"
                                size="sm"
                                className="rounded-circle mr-1"
                                onClick={() => {
                                  setFunctionSelected(task);
                                  setFuncion(true);
                                  setContinue(true);
                                  dispatch(
                                    getGeneralInfo({
                                      tipo_busqueda: "posicion_id",
                                      filter: parseInt(task.id),
                                    })
                                  );
                                }}
                              >
                                <i className="material-icons">add</i>
                              </Button>
                            </OverlayTrigger>
                            <LinkDescriptor
                              loader={
                                loadingGeneralInfo ||
                                jobLoading ||
                                experienceLoading ||
                                technicalKnowledgeAcquiredLoading ||
                                preparationLoading ||
                                trainingLoading ||
                                loaderIndikators
                              }
                              value={task}
                              functionSelected={functionSelected}
                            />
                          </ButtonGroup>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            ) : (
              <Alert variant="info" className="my-4">
                Sin registros que mostrar.
              </Alert>
            )}
          </div>
        </Modal.Body>
      </Modal>
      {/* <Modal
        show={showModalPosition}
        onHide={() => setShowModalPosition(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title className="text-muted">Seleccionar puesto</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row className="justify-content-end align-items-center flex-nowrap">
            <Col xs="auto">
              <Form.Label className="m-0" htmlFor="filterEmployee">
                <b>{tipoBusquedaPosition.desc}:</b>
              </Form.Label>
            </Col>
            <Col xs="auto">
              <Form.Control
                id="filterEmployee"
                name="filterEmployee"
                className={`rounded-pill form-control-sm`}
                type="search"
                onKeyDown={onSearchPosition}
              ></Form.Control>
              <Form.Control.Feedback type="invalid">
                **Campo requerido
              </Form.Control.Feedback>
            </Col>
            <Col>
              <ButtonGroup>
                <OverlayTrigger
                  placement="auto"
                  overlay={<Tooltip {...props}>Seleccionar Filtrado</Tooltip>}
                >
                  <Dropdown className="ml-3 mr-3">
                    <Dropdown.Toggle variant="primary" className="btn-sm font">
                      <i className="material-icons">filter_list</i>
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      {filtersPosition.map((item) => (
                        <Dropdown.Item
                          onClick={() => setTipoBusquedaPosition(item)}
                          key={item.id}
                        >
                          {item.desc}
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                </OverlayTrigger>
              </ButtonGroup>
            </Col>
          </Row>
          <div className="my-3">
            {loaderPlazasVacantes ? (
              <div className="d-flex justify-content-center">
                <Spinner
                  animation="border"
                  role="status"
                  className="d-flex justify-content-center"
                />
              </div>
            ) : plazasVacantes && plazasVacantes.count > 0 ? (
              <div>
                <Table responsive>
                  <tbody>
                    {plazasVacantes.data.map((plaza) => (
                      <tr>
                        <td>
                          {plaza.codigo} / {plaza.descripcion}
                        </td>
                        <td>
                          <ButtonGroup>
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip
                                  style={{ zIndex: 999999999999 }}
                                  {...props}
                                >
                                  Seleccionar puesto
                                </Tooltip>
                              }
                            >
                              <Button
                                variant="light"
                                size="sm"
                                className="rounded-circle mr-1"
                                onClick={() => {
                                  setPositionSelected(plaza);
                                  setShowModalPosition(false);
                                }}
                              >
                                <i className="material-icons">add</i>
                              </Button>
                            </OverlayTrigger>
                          </ButtonGroup>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            ) : (
              <Alert variant="info" className="my-4">
                Sin registros que mostrar.
              </Alert>
            )}
          </div>
        </Modal.Body>
      </Modal> */}
    </>
  );
};

export default FactorQuestions;
